var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 496H16V16H176V496Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336 496H176V16H336V496Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H336V16H496V496Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.827 182.915C250.92 196.296 245.919 210.224 235.218 220.888C238.54 219.793 244.353 218.812 248.089 218.906V275.185L232.198 277.544C231.632 277.488 231.443 276.601 231.443 275.393C229.915 257.916 225.782 243.233 221.026 228.04C220.686 225.964 214.665 218.038 219.308 219.434C219.874 219.51 226.084 222.039 225.102 220.831C216.647 212.074 204.285 205.77 192.282 203.902C191.225 203.638 190.602 204.166 191.546 205.393C207.475 229.909 220.799 258.841 220.686 293.171C226.876 293.171 241.88 289.51 248.089 289.51V329.219H255.922L257.715 218.321L255.827 182.915Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/BB.78bebd8496921ae10ef4c6422ede5f0b.svg";
export { ForwardRef as ReactComponent };